import { Deferred } from '@inertiajs/react'
import { CsatReport } from '@/components/analytics/CsatReport'
import { PanelSkeleton } from '@/components/analytics/PanelSkeleton'
import { usePanel } from '@/components/analytics/usePanel'
import type { CsatPanel } from '@/types/analytics'

export function CsatSection() {
  return (
    <div className="space-y-4">
      <Deferred data="csat" fallback={<PanelSkeleton className="h-96" />}>
        <CsatDeferred />
      </Deferred>
      <p className="text-xs text-muted-foreground">
        Ratings are collected by emailing visitors after a conversation is resolved. Enable and
        customise this under Settings → Customer satisfaction.
      </p>
    </div>
  )
}

function CsatDeferred() {
  const data = usePanel<CsatPanel>('csat')
  return data ? <CsatReport data={data} /> : null
}
